export const DocumentoValidacaoTipo = Object.freeze({
  DOCUMENTO: 'DOCUMENTO',
});
